import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type { PatientDemographics } from "../types/patientDemographics";

export const usePatientDemographics = (patientId: string) => {
  return useApi<PatientDemographics>({
    queryOptions: {
      enabled: Boolean(patientId),
      queryFn: async () => {
        const response = await axiosInstance.get<PatientDemographics>(
          `/new-api/patient/${patientId}/demographic-bar`,
        );
        return response.data;
      },
      queryKey: QueryKeys.Patient.Demographics.DEFAULT(patientId),
    },
  });
};
